import { createSlice } from '@reduxjs/toolkit'
import { OXE_LOGIN } from '../../utils/Constants'
import { getDefaultLanguage } from '../../utils/CommonUtils'
import { setSessionItem } from '../../utils/storageUtils'

export const CommonReducer = createSlice({
    name: 'common',
    initialState: {
        selectedApp: "",
        subHeading: "",
        additionalSubHdView: null,
        loading: false, // App level loader
        contentLoading: false, // Content area level loader
        language: getDefaultLanguage(),
        tableFilter: [],
        dict: {},
        timerArr: [],
        pageFromIndex: 0,
        dynamicPagnItemCount: 0,
        currentMergedData: null,
        currModalMergedData: null,
        currDirectoryMergedData: null,
        baseMergeData: null,
        baseModalMergeData: null,
        baseDIrectoryMergedData:null,
        filter: '',
        fieldFilter: '',
        dateFilter: '',
        sortField: '',
        sortType: '',
        extraContent: [],
        validateState: false, // to notify whether to apply attr level validation
        umcNotification: {
            type: "",
            message: "",
            description: ""
        },
        textFieldErr: {
            id: "",
            status: ""
        },
        isUnSavedDataExists: false,
        oxeErrorCodes: {},
        persistedSort: {}
    },
    reducers: {
        setSelectedApplication: (state, action) => {
            state.selectedApp = action.payload
            state.subHeading = "" // Reset subHeading on App change
            state.additionalSubHdView = null
            state.contentLoading = false // Reset contentLoading state on App change
            state.extraContent = []
        },
        setSubHeading: (state, action) => {
            state.subHeading = action.payload
        },
        setAdditionalSubHdView: (state, action) => {
            state.additionalSubHdView = action.payload
        },
        setLoader: (state, action) => {
            state.loading = action.payload
        },
        setLanguage: (state, action) => {
            state.language = action.payload
            setSessionItem("language", action.payload)
        },
        setTableFilter: (state, action) => {
            state.tableFilter = action.payload
        },
        setDict: (state, action) => {
            state.dict = action.payload
        },
        setContentLoading: (state, action) => {
            state.contentLoading = action.payload
        },
        setTimerArr: (state, action) => {
            state.timerArr = action.payload
        },
        setPageFromIndex: (state, action) => {
            state.pageFromIndex = action.payload
        },
        setDynamicPagnItemCount: (state, action) => {
            state.dynamicPagnItemCount = action.payload
        },
        setCurrentMergedData: (state, action) => {
            state.currentMergedData = action.payload
            state.baseMergeData = action.payload ? state.baseMergeData : null
        },
        setCurrModalMergedData: (state, action) => {
            state.currModalMergedData = action.payload
            state.baseModalMergeData = action.payload ? state.baseModalMergeData : null
        },
        setCurrDirectoryMergedData: (state, action) => {
            state.currDirectoryMergedData = action.payload
            state.baseDIrectoryMergedData = action.payload ? state.baseDIrectoryMergedData : null
        },
        setBaseMergeData: (state, action) => {
            state.baseMergeData = action.payload
        },
        setBaseModalMergeData: (state, action) =>{
            state.baseModalMergeData = action.payload
        },
        setBaseDIrectoryMergedData: (state, action) =>{
            state.baseDIrectoryMergedData = action.payload
        },
        setFilter: (state, action) => {
            state.filter = action.payload;
        },
        setFieldFilter: (state, action) => {
            state.fieldFilter = action.payload;
        },
        setDateFilter: (state, action) => {
            state.dateFilter = action.payload;
        },
        setSortField: (state, action) => {
            state.sortField = action.payload;
        },
        setSortType: (state, action) => {
            state.sortType = action.payload;
        },
        setExtraContent: (state, action) => {
            state.extraContent = action.payload;
        },
        setValidateState: (state, action) => {
            state.validateState = action.payload
        },
        setUmcNotification: (state, action) => {
            state.umcNotification = action.payload
        },
        setTextFieldErr: (state, action) => {
            state.textFieldErr = action.payload
        },
        setIsUnSavedDataExists: (state, action) => {
            state.isUnSavedDataExists = action.payload
        },
        setOxeErrorCodes: (state, action) => {
            state.oxeErrorCodes = action.payload
        },
        setpersistedSort: (state, action) => {
            state.persistedSort[action.payload.tab] = {
                columnId: action.payload?.columnId,
                order: action.payload?.order
            }
        }
    },
})

// Action creators are generated for each case reducer function
export const { setSelectedApplication, setSubHeading, setAdditionalSubHdView, setLoader, setLanguage, setTableFilter,
    setCurrentMergedData, setCurrModalMergedData, setBaseMergeData, setBaseModalMergeData, setDict, setContentLoading, setTimerArr, setPageFromIndex,
    setDynamicPagnItemCount, setFilter, setFieldFilter, setDateFilter, setSortField, setSortType, setExtraContent,
    setValidateState, setUmcNotification, setTextFieldErr, setIsUnSavedDataExists, setOxeErrorCodes,
    setCurrDirectoryMergedData, setBaseDIrectoryMergedData, setpersistedSort } = CommonReducer.actions

export default CommonReducer.reducer